import React from "react";
import { useAtom } from "jotai";
import { confirmState } from "./state.js";
import "../App.css";

const ConfirmLayout = ({
  msg = "",
  onConfirm = () => {},
  onCancel = () => {},
}) => {
  return (
    <div className="modal-overlay">
      <div className="modal-content">
        <p className="pre-line">{msg}</p>
        <div className="modal-buttons">
          <button className="confirm-button" onClick={onConfirm}>
            확인
          </button>
          <button className="cancel-button" onClick={onCancel}>
            취소
          </button>
        </div>
      </div>
    </div>
  );
};

const Confirm = React.memo(() => {
  const [state, setState] = useAtom(confirmState);
  return (
    <>
      {state.isOpen && (
        <ConfirmLayout
          msg={state.msg}
          onConfirm={state.onConfirm}
          onCancel={() => setState({ ...state, isOpen: false })}
        ></ConfirmLayout>
      )}
    </>
  );
});

export default Confirm;

export const useConfirm = () => {
  const [state, setState] = useAtom(confirmState);
  return (msg = "", onConfirm = () => {}) => {
    setState({
      ...state,
      isOpen: true,
      msg: msg,
      onConfirm: () => {
        setState({ ...state, isOpen: false });
        onConfirm();
      },
    });
  };
};
